import { useContext } from 'react';
import { AppContext, AppContextType } from '../AppContext';

export interface FeaturesSortingOptionType extends Pick<AppContextType, 'sortFeaturesBy' | 'setSortFeaturesBy'> {}

export function useFeaturesSortingOption(): FeaturesSortingOptionType {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useFeaturesSortingOption must be used within a AppContextProvider');
  }
  const { sortFeaturesBy, setSortFeaturesBy } = context;

  return {
    sortFeaturesBy,
    setSortFeaturesBy,
  };
}
